import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ChakraProvider, Flex, FormLabel, Switch } from '@chakra-ui/react';
import SignOut from './utils/SignOut';
import Document from './pages/Document/Document';
import FormBuilder from './pages/FormBuilder';
import NewDocument from './pages/NewDocument/NewDocument';
import ErrorBoundary from './ErrorBoundary';
import { useTheme } from './context/ThemeContext'
import PrivateRoute from './routes/PrivateRoute';
import DocumentCreateConfirm from './pages/Document/DocumentCreateConfirm';

import './App.css';
import AuthRedirect from './pages/AuthRedirect';

const App: React.FC = () => {

  const { theme, toggleTheme } = useTheme();


  return (
    <ErrorBoundary>
      <ChakraProvider>

        <Router>
          <Flex className="site-header" alignItems="center" justifyContent="center" padding="10px">
            <FormLabel htmlFor="mode-switch" mb="0">Change mode</FormLabel>
            <Switch className="mode-switch" isChecked={theme === 'dark'} onChange={toggleTheme} />
          </Flex>
          <Routes>
            <Route
              path="/"
              element={
                <AuthRedirect />
              }
            />
            <Route
              path="/signout"
              element={
                <PrivateRoute>
                  <SignOut />
                </PrivateRoute>
              }
            />
            <Route
              path="/:project_id/:document_id/:template_name"
              element={
                <PrivateRoute>
                  <Document />
                </PrivateRoute>
              }
            />
            <Route
              path="/:project_id/:document_id/:template_name/:step_number"
              element={
                <PrivateRoute>
                  <FormBuilder />
                </PrivateRoute>
              }
            />
            <Route
              path="/:project_id/:template_name"
              element={
                <PrivateRoute>
                  <NewDocument />
                </PrivateRoute>
              }
            />
            <Route
              path="/documents/confirm"
              element={
                <PrivateRoute>
                  <DocumentCreateConfirm />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ChakraProvider>
    </ErrorBoundary>


  );
};

export default App;